import { useEffect, useState } from 'react';
import { withRouter } from '../../../common/with-router';
import Loading from '../../../components/global/loading';
import { getAdminDashboard } from '../../../api/Reports';
import {faFilePdf, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Entries from "../entries/entries";
import EntriesTable from "../../../components/dashboard/EntriesTable";
import DashboardEntriesTable from "../../../components/dashboard/EntriesTable";
import DashboardOverviewStats from "../../../components/dashboard/StatsOverview";

const AdminDashboard = (props) => {
	const [loading, setLoading] = useState(true);
	const [dashboard, setDashboard] = useState({});

	const getInitialData = async () => {
		const response = await getAdminDashboard();
		if (response.data.status === 'success') {
			setDashboard(response.data);
			setLoading(false);
		} else {
			console.log('Error');
		}
	}

	useEffect(() => {
		getInitialData();
	}, []);


	if (loading) {
		return <Loading />;
	}

	const dashboardEntriesTableHeaders = () => {
		return [
			{
				label: 'Event',
			},
			{
				label: 'Max',
			},
			{
				label: 'Total',
				separator: true
			},
			{
				label: 'H/O',
				popover: {
					content: 'Home and Overseas split'
				},
			},
			{
				label: 'T',
				popover: {
					content: 'Through crews'
				},
				separator: true

			},
			{
				label: 'Q',
				popover: {
					content: 'Crews that must qualify'
				}
			},
			{
				label: 'Y/F',
				popover: {
					content: 'Crews that have qualified (Y) and crews that failed to qualify (F).'
				},
			},
			{
				label: 'B',
				popover: {
					content: 'Crews that have withdrawn before qualifiers.'
				},
				separator: true
			},
			{
				label: 'X',
				popover: {
					content: 'Crews that have withdrawn after qualifiers but before racing.'
				},
				separator: true
			},
			{
				label: 'W',
				popover: {
					content: 'Crews that have withdrawn after their first race (note this also includes withdrawing at the start line or during the race).'
				}
			}
		];
	}

	return (
		<div className="container-fluid">
			<div className="dashboard-header row">
				<div className="col-12 col-md-5">
					<h4>Welcome</h4>
					<h1>Entries Dashboard</h1>
				</div>
				<DashboardOverviewStats data={dashboard?.globalStats}/>
			</div>
			{dashboard.entryStats && (
				<div>
					<h2>Entries per event</h2>
					<DashboardEntriesTable data={dashboard?.entryStats} headers={dashboardEntriesTableHeaders()}/>
				</div>
			)}
		</div>
	);
}

export default withRouter(AdminDashboard);
